import { updatesList } from '@/mocks/homeData';

const typeStyles: Record<string, { bg: string; text: string; icon: string }> = {
  system: { bg: 'bg-primary-100', text: 'text-primary-700', icon: 'ri-server-line' },
  feature: { bg: 'bg-accent-100', text: 'text-accent-700', icon: 'ri-sparkling-line' },
  update: { bg: 'bg-secondary-100', text: 'text-secondary-700', icon: 'ri-refresh-line' },
  team: { bg: 'bg-accent-50', text: 'text-accent-600', icon: 'ri-team-line' },
};

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-4 whitespace-nowrap">
            <i className="ri-timeline-view"></i>
            平台动态
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            平台更新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">51吃瓜网最新平台动态与功能更新</p>
        </div>

        <div className="max-w-[800px] mx-auto relative">
          <div className="absolute left-[19px] top-2 bottom-2 w-px bg-background-200"></div>

          <div className="space-y-6">
            {updatesList.map((item, idx) => {
              const style = typeStyles[item.type] || typeStyles.update;
              return (
                <div key={idx} className="relative flex gap-5 pl-[50px]">
                  <div className={`absolute left-1 w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0 ${style.bg} ${style.text}`}>
                    <i className={`${style.icon} text-sm`}></i>
                  </div>
                  <div className="flex-1 pb-6 border-b border-background-100">
                    <div className="flex items-center gap-2 mb-1 flex-wrap">
                      <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                      <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap ${style.bg} ${style.text}`}>
                        {item.title}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{item.content}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}